import React from "react";
import Indicator from "../../Indicator";
import { compose } from "redux";
import { withTranslation } from "react-i18next";
import { MenuItem, TextField } from "@material-ui/core";

class ListeFourrage extends React.Component {
  render() {
    const {
      indicateur,
      onChangeIndicator,
      sousRubriqueIndex,
      libelleEnglobantIndex,
      changeIndicateur,
      valueInputProps,
      computedFields,
    } = this.props;

    const listePrairiePermanente = [
      {
        libelle: "Commercialisation",
        value: "COMMERCIALISATION",
      },
      {
        libelle: "Autoconsommation",
        value: "AUTOCONSOMMATION",
      },
    ];

    const valueRendered = (
      <TextField
        fullWidth={false}
        InputProps={valueInputProps}
        select
        value={indicateur.valeur.value}
        style={{
          fontWeight: indicateur.afficherGras ? "bold" : "normal",
          width: "20rem",
        }}
        disabled={computedFields.includes(indicateur.codeNational)}
        onChange={(event) =>
          changeIndicateur(
            { ...indicateur, valeur: { value: event.target.value } },
            sousRubriqueIndex,
            libelleEnglobantIndex
          )
        }
      >
        {listePrairiePermanente.map((element) => (
          <MenuItem key={element.value} value={element.value}>
            {element.libelle}
          </MenuItem>
        ))}
      </TextField>
    );

    return (
      <Indicator indicateur={indicateur} onChange={onChangeIndicator}>
        {valueRendered}
      </Indicator>
    );
  }
}

export default compose(withTranslation())(ListeFourrage);
